import { useState } from "react";
import { SITES } from "../sites";

const STORAGE_KEY = "selectedSite";
const DEFAULT_SITE = "1";

const getInitialSite = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && SITES.some((s) => s.value === stored)) return stored;
  } catch {
    // localStorage 접근 불가 환경
  }
  return DEFAULT_SITE;
};

const useSelectedSite = () => {
  const [selectedSite, setSelectedSiteState] = useState(getInitialSite);

  const setSelectedSite = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      // ignore
    }
    setSelectedSiteState(value);
  };

  return { selectedSite, setSelectedSite };
};

export default useSelectedSite;
